import { postWithToken } from './http-client';

export default {
  async consultar(consultaRequest, token) {
    return postWithToken(
      `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/ConsultasRegionalizacion`,
      consultaRequest,
      token
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },

  async consultaMarcaBlanca(consultaRequest, token) {
    return postWithToken(`${process.env.RAZZLE_API_MARCA_BLANCA}/consultas`, consultaRequest, token)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },

  async reclamoMarcaBlanca(consultaRequest, token) {
    return postWithToken(`${process.env.RAZZLE_API_MARCA_BLANCA}/reclamos`, consultaRequest, token)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },

  async enviarMailContacto(data, token) {
    return postWithToken(`${process.env.RAZZLE_API_MARCA_BLANCA}/contacto`, data, token)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },

  async enviarMailConsulta(data, token) {
    return postWithToken(
      `${process.env.RAZZLE_API_MARCA_BLANCA}/contacto/marca-blanca`,
      data,
      token
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },

  async enviarMailArrepentimiento(data, token) {
    return postWithToken(
      `${process.env.RAZZLE_API_MARCA_BLANCA}/contacto/arrepentimiento`,
      data,
      token
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },

  async enviarMailReclamo(data, token) {
    return postWithToken(`${process.env.RAZZLE_API_MARCA_BLANCA}/contacto/reclamo`, data, token)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
};
